export default __webpack_public_path__ + "static/flashcard_back_and_forth-05c0dbf72cf79be23822705dc7c9ee4e.png";